import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, User, KeyRound } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = window.location.origin + '/api';

const ForgotPasswordPage = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetToken, setResetToken] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !email) {
      toast.error('Lutfen tum alanlari doldurun');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/auth/forgot-password`, {
        username,
        email
      });

      if (response.data.reset_token) {
        setResetToken(response.data.reset_token);
        toast.success('Sifre sifirlama baglantisi olusturuldu');
      } else {
        toast.info(response.data.message);
      }
    } catch (error) {
      const message = error.response?.data?.detail || 'Bir hata olustu';
      toast.error(message);
    }
    setLoading(false);
  };

  if (resetToken) {
    return (
      <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center px-4">
        <div className="w-full max-w-md">
          <div className="bg-[#121214] rounded-2xl p-8 border border-white/5 text-center">
            <div className="w-16 h-16 rounded-full bg-emerald-500/10 flex items-center justify-center mx-auto mb-6">
              <KeyRound className="w-8 h-8 text-emerald-400" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">Sifirlama Baglantisi Hazir</h2>
            <p className="text-slate-400 mb-6">
              Asagidaki butona tiklayarak yeni sifrenizi belirleyebilirsiniz. Bu baglanti 1 saat gecerlidir.
            </p>
            <Button
              onClick={() => navigate(`/sifre-sifirla?token=${resetToken}`)}
              className="w-full h-12 bg-cyan-600 hover:bg-cyan-500 text-white font-semibold shadow-[0_0_15px_rgba(6,182,212,0.3)]"
            >
              Sifremi Sifirla
            </Button>
            <p className="mt-4 text-sm text-slate-500">
              Veya bu baglanti: <code className="text-cyan-400 text-xs break-all">{window.location.origin}/sifre-sifirla?token={resetToken}</code>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0A0B] flex">
      <div className="flex-1 flex flex-col justify-center px-4 sm:px-6 lg:px-20 xl:px-24">
        <div className="w-full max-w-sm mx-auto">
          <Link to="/giris" className="inline-flex items-center gap-2 text-slate-400 hover:text-white mb-8 transition-colors duration-200">
            <ArrowLeft className="w-4 h-4" />
            <span>Girise Don</span>
          </Link>

          <div className="flex items-center gap-2 mb-8">
            <img src="/logo.png" alt="BestURL" className="h-10 w-auto" />
          </div>

          <div className="mb-8">
            <h1 className="text-3xl font-bold text-white mb-2">Sifremi Unuttum</h1>
            <p className="text-slate-400">Kullanici adinizi ve e-posta adresinizi girerek sifrenizi sifirlayabilirsiniz.</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="username" className="text-slate-300">Kullanici Adi</Label>
              <div className="relative">
                <Input
                  id="username"
                  type="text"
                  placeholder="kullaniciadi"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="h-12 bg-[#1C1C1E] border-white/10 text-white placeholder:text-slate-500 pl-12"
                />
                <User className="w-5 h-5 text-slate-500 absolute left-4 top-1/2 -translate-y-1/2" />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="email" className="text-slate-300">E-posta Adresi</Label>
              <div className="relative">
                <Input
                  id="email"
                  type="email"
                  placeholder="ornek@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="h-12 bg-[#1C1C1E] border-white/10 text-white placeholder:text-slate-500 pl-12"
                />
                <Mail className="w-5 h-5 text-slate-500 absolute left-4 top-1/2 -translate-y-1/2" />
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full h-12 bg-cyan-600 hover:bg-cyan-500 text-white font-semibold shadow-[0_0_15px_rgba(6,182,212,0.3)] hover:shadow-[0_0_25px_rgba(34,211,238,0.5)] disabled:opacity-50"
            >
              {loading ? (
                <div className="spinner w-5 h-5" />
              ) : (
                'Sifre Sifirlama Baglantisi Olustur'
              )}
            </Button>
          </form>

          <p className="mt-8 text-center text-slate-400">
            Sifrenizi hatirladiniz mi?{' '}
            <Link to="/giris" className="text-cyan-400 hover:text-cyan-300 font-medium">
              Giris Yap
            </Link>
          </p>
        </div>
      </div>

      <div className="hidden lg:flex flex-1 items-center justify-center bg-[#0d0d0e] p-12">
        <div className="max-w-md">
          <div className="bg-[#121214] rounded-2xl p-8 border border-white/5">
            <div className="w-16 h-16 rounded-full bg-cyan-500/10 flex items-center justify-center mx-auto mb-6">
              <KeyRound className="w-8 h-8 text-cyan-400" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4 text-center">Sifre Sifirlama</h3>
            <div className="space-y-4 text-sm text-slate-400">
              <div className="flex items-start gap-3">
                <span className="text-cyan-400 font-bold">1.</span>
                <span>Kullanici adinizi ve kayitli e-posta adresinizi girin</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-cyan-400 font-bold">2.</span>
                <span>Bilgileriniz dogrulanirsa sifirlama baglantisi olusturulur</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-cyan-400 font-bold">3.</span>
                <span>Yeni sifrenizi belirleyin ve giris yapin</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
